var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.792a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 167.72h512v176.55H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M372.816 322.934v-12.518h-4.172v-8.344h-4.173v-8.343h-4.172v-8.344h-12.516v-25.032h-.001l4.173-4.172v-12.516h-4.172v-8.344h-4.172v-12.516h-4.171v-8.344h-4.172v-8.344h-4.172v-4.172h-8.345v4.172h-4.172v8.344h-4.172v8.344h-4.171v12.516h-4.172v8.344h-25.033v-12.516h-4.171v-12.516h-4.172v-12.516h-4.172v-8.344h-4.172v-8.344h-4.172v-4.172h-2.086v-4.172h-4.172v4.172h-2.087v4.172h-4.171v8.344h-4.172v8.344h-4.172v12.516h-4.172v12.516h-4.172v12.516h-25.032v-8.344h-4.172v-12.516h-4.172v-8.344h-4.172v-8.344h-4.172v-4.172h-8.344v4.172h-4.172v8.344h-4.172v8.344h-4.172v12.516h-4.172v8.344h-4.172v12.516l4.17 4.172h.002v25.032h-12.515v8.344h-4.172v8.343h-4.173v8.344h-4.172v12.518h-4.172v12.514h241.975v-12.514z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.3f9781c9563509c66104b5b3a86867d1.svg";
export { ForwardRef as ReactComponent };